import { Form, Text, NestedField, Checkbox, Field } from 'react-form';
import Select from 'react-select';
import SignInLoader from './SignInLoader';
import { AbconetApi } from '../General/AbconetApi';
import $ from "jquery";



function validate(email, password) {
    // true means invalid, so our conditions got reversed
    return {
        email: email.length === 0, //true if email is empty
        password: password.length === 0, //true if password is empty
    };
}

function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

export class UserLogin extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            password: '',
            errorMessage: '',
            staySignedIn: false,

            touched: {
                email: false,
                password: false
            }
        }
    }

    handleEmailChange (evt) {
        this.setState({ email: evt.target.value });
    }

    handlePasswordChange  (evt){
        this.setState({ password: evt.target.value });
    }

    handleStaySignedInChange(evt) {
        this.setState({ staySignedIn: evt.target.checked });
    }

    handleBlur  (field)  {
        this.setState({
            touched: { ...this.state.touched, [field]: true },
        });
    }

    handleSubmit (evt){
        evt.preventDefault();
        const { email, password, staySignedIn } = this.state;

        this.setState({ isLoading: true });

        AbconetApi.post(`/api/user/login`, { username: email, password: password, staySignedIn: staySignedIn }).then((data) => {

            if (data.success) {
                dataLayer.push({
                    'event': 'login',
                    'loginMethod': 'abconet' 
                });
                if (this.props.redirect) {
                    
                    var redirectUrl = getUrlParameter('redirect');

                    if (redirectUrl != null) {
                        window.location.href = '/' + redirectUrl.substring(1);
                    } else {
                        window.location.reload();
                    }
                } else {
                    window.location.href = '/';             
                }
            }
            else {
                this.setState({ errorMessage: data.msg, isLoading: false});
            }

        });
    }

    canBeSubmitted() {
        const errors = validate(this.state.email, this.state.password);
        const isDisabled = Object.keys(errors).some(x => errors[x]);
        return !isDisabled;
    }

    renderErrorMessage() {
        if (this.state.errorMessage.length > 0) {
            return <div className="alert alert-danger bg-white mt-2 text-danger container">{this.state.errorMessage}</div>;
        }

        return null;
    }

    renderSubmitButton() {
        const errors = validate(this.state.email, this.state.password);
        var isDisabled = Object.keys(errors).some(x => errors[x]);
        var extraClass = "";
        if (this.state.isLoading) {
            isDisabled = true;
            extraClass = " saving";
        }

        return <button disabled={isDisabled} className={"btn btn-secondary ml-2 " + extraClass}>Login</button>;
    }

    render() {
        const errors = validate(this.state.email, this.state.password);

        const shouldMarkError = (field) => {
            const hasError = errors[field];
            const shouldShow = this.state.touched[field];

            return hasError ? shouldShow : false;
        };

        return (
            <React.Fragment>
                {this.state.isLoading && <SignInLoader />}
            <form onSubmit={this.handleSubmit.bind(this)}>
                <div className="form-group">
                    <label htmlFor="loginModel_Username">Email</label>
                    <input
                        className={shouldMarkError('email') ? "error form-control" : " form-control"}
                        type="text"
                        id="loginModel_Username"
                        placeholder="Enter email"
                        value={this.state.email}
                        onChange={this.handleEmailChange.bind(this)}
                        onBlur={this.handleBlur.bind(this, 'email')}
                    />
                    <span className={shouldMarkError('email') ? "error field-validation-valid" : "d-none"}>A valid email is required.</span>
                </div>
                <div className="form-group">
                    <label htmlFor="loginModel_Password">Password</label>
                    <input
                        id="loginModel_Password" 
                        className={shouldMarkError('password') ? "error form-control" : " form-control"}
                        type="password"
                        placeholder="Enter password"
                        value={this.state.password}
                        onChange={this.handlePasswordChange.bind(this)}
                        onBlur={this.handleBlur.bind(this, 'password')}
                    />
                    <span className={shouldMarkError('password') ? "error field-validation-valid" : "d-none"}>A password is required.</span>
                </div>
                <div className="form-group">
                    <div className="custom-control custom-checkbox mr-sm-2">
                        <input type="checkbox" className="custom-control-input" id="stay-logged-in" checked={this.state.staySignedIn} onChange={this.handleStaySignedInChange.bind(this)}/>
                        <label className="custom-control-label" htmlFor="stay-logged-in">Stay signed in</label>
                    </div>
                </div>
                <div className="form-group">
                    <a href="/password-reset">Forgot password?</a>
                    {this.renderSubmitButton()}
                    {this.renderErrorMessage()}
                </div>
                </form>
                </React.Fragment>
        );
    }
}